import { render, staticRenderFns } from "./ObiForm.vue?vue&type=template&id=52d32cc3&scoped=true&"
import script from "./ObiForm.vue?vue&type=script&lang=js&"
export * from "./ObiForm.vue?vue&type=script&lang=js&"
import style0 from "./ObiForm.vue?vue&type=style&index=0&id=52d32cc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d32cc3",
  null
  
)

export default component.exports